import {observer} from "mobx-react";
import React, {useContext, useEffect, useRef, useState} from "react";
import styled from "styled-components";
import DepartureOption from "./DepartureOption";
import ApiSearchInput from "../../Organisms/APISearchInput";
import Button from "../../Button";
import CheckboxInput from "../../Inputs/CheckboxInput/CheckboxInput";
import LinkToCounterAgent from "./LinkToCounterAgent";
import {VerificationCenterCalendarModalStore} from "./index.verificationCenter.store";
import FormInput from "../../Inputs/FormInput/FormInput";
import {AuthContext} from "../../../context/AuthContext";

const store = new VerificationCenterCalendarModalStore()

const VerCenterCalendarModal = observer((props) => {
    const getCalendarId = () => {
        return props?.event?.source?.id
    }
    const userId = useContext(AuthContext)?.token?.userId

    useEffect(() => {

        store.setOldDepartures(props.event.source.departures)
        store.setHoliday(props?.event?.source?.is_holliday, 'sad')
        return () => {
            store.reset()
            props.setModal(null)
        }
    }, [])

    useEffect(() => {
        store.setInfo(props?.event?.source?.info, userId)

    }, [props?.event?.source?.info])


    const onSaveEditedAmo = () => {
        store.validate()
        if (store?.error?.length === 0)
            props.onSaveEditedAmo(store.prepareToSaveEdited(), getCalendarId())
    }


    const save = () => {
        store.validate()
        if (store.oldDepartures.length < 1) {
            onSaveAddedAmo()
        } else {
            onSaveEditedAmo()
        }
    }

    const onSaveAddedAmo = () => {
        store.validate()
        if (store?.error?.length === 0)
            props.onSaveAddedAmo(store.prepareToAdd())

    }

    const deleteDepartureItem = (event) => {

        store.deleteDeparture(event, _ => props.deleteEvent(getCalendarId(), event.id))

    }

    const deleteCalendar = () => {
        props.deleteCalendarById(getCalendarId())
    }
    return (
        <Styled className={props.className}>
            <div className="modal scale-up-hor-left">
                <div className={"close"} onClick={() => props.setModal(null)}><i className="fas  fa-times"/></div>

                <div className="main">


                    <LinkToCounterAgent info={store.info} type={'medCenter'}>
                        {store?.info?.medCenter?.name ? (
                            <ApiSearchInput
                                hideIcon
                                reset={store.isHolliday}
                                disabled={store.isHolliday}
                                title='Мед. центр'
                                chooseHandler={(id, name) => {
                                    store.infoHandler('medCenter', id, name)
                                }}
                                orgType='medcenter'
                                initialValue={store?.info?.medCenter?.name}
                            />
                        ) : (<FormInput hideIcon title='Мед. центр'
                        />)}

                    </LinkToCounterAgent>

                    <LinkToCounterAgent info={store.info} type={'organization'}>
                        {store?.info?.organization?.name ? (
                            <ApiSearchInput
                                disabled={store.isHolliday}
                                reset={store.isHolliday}
                                important
                                hideIcon
                                title='Организация'
                                chooseHandler={(id, name) => {
                                    store.infoHandler('organization', id, name)
                                }}
                                orgType='organization'
                                initialValue={store?.info?.organization?.name}
                            />
                        ) : (<FormInput hideIcon title='Организация'
                        />)}


                    </LinkToCounterAgent>


                    <div className="errors">
                        {store?.error?.length > 0 && <div className="error">{store.error[0]}</div>}
                    </div>

                    <CheckboxInput checked={store?.isHolliday} onClick={_ => store.setHoliday(!store?.isHolliday)}
                                   title="Нерабочий день"/>
                </div>
                <div className="optional">
                    <div className='top'>
                        <div className='title'>Выезды</div>
                        <div className='add'>
                            <button onClick={store.createDeparture}><i className="fas fa-plus"/> Добавить выезд</button>
                        </div>
                    </div>
                    {store
                        .getAllDepartures()
                        .map(departure =>
                            <DepartureOption
                                isOpen={store.departureInFocus === (departure._id || departure.id)}
                                key={departure._id  || departure.id}
                                deleteDeparture={deleteDepartureItem}
                                id={departure._id || departure.id}
                                save={store.saveDeparture}
                                open={() => store.setDepartureInFocus(departure._id || departure.id)}
                                className={'option'}
                                form={departure}/>
                        )}
                </div>
                <div className="buttonArea">
                    <Button color={"red"} onClick={deleteCalendar} text={"Удалить"}/>
                    <Button onClick={save} text={"Сохранить"}/>
                </div>
            </div>

        </Styled>
    )
})


const Styled = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;

  .buttonArea {
    button {
      margin: 5px;

    }

  }

  .modal {
    width: 50%;
    background: white;
    overflow: overlay;
    padding: 0 30px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .close {
      position: absolute;
      right: 15px;
      top: 5px;
      width: 30px;
      z-index: 5;
      cursor: pointer;

      .fas {
        font-size: 30px;
        color: #009FF5;
      }
    }

  }

  .errors {
    height: 25px;
    margin-bottom: 10px;

    .error {
      height: 25px;
      border-radius: 5px;
      background: indianred;
      color: white;
      text-align: center;
      padding: 1.5px 5px;
      font-size: 14px;
    }
  }

  .main {
    width: 100%;
    padding-bottom: 30px;

    .linkToAmo {
      margin-top: 5px;
      margin-bottom: 15px;
      text-decoration: underline;
    }
  }

  .optional {
    width: 100%;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .title {
        font-size: 24px;
      }

      button {
        background: #009fff;
        height: 34px;
        border-radius: 100px;
        color: white;
        padding: 0 15px;

        .fas {
          color: white;
          margin-right: 5px;
        }
      }
    }

    .option {
      margin-bottom: 20px;
    }
  }

`


export default VerCenterCalendarModal